import styled, { css } from 'styled-components'

import { BREAKPOINTS_INTS } from '../../styles/constants'

const MODAL_BREAKPOINT = `${BREAKPOINTS_INTS.sm + 1}px`

export type ModalLayout = 'default' | 'fullScreenOnMobile' | 'fullScreenOnMobileCustom'

/** Wrapper for layout overrides and aria/close-button DOM queries. */
export const ModalContainer = styled.div<{
	$layout: ModalLayout
	$hideDefaultCloseButton: boolean
	$desktopMaxWidth: number
}>`
	${({ $layout, $hideDefaultCloseButton, $desktopMaxWidth }) =>
		$layout === 'fullScreenOnMobileCustom' &&
		css`
			position: relative;
			height: 100%;

			/* RemoveScroll > ModalBackground */
			> div > div {
				overflow-y: auto;
			}

			& div[role='dialog']:first-of-type {
				position: relative;
				max-width: 100vw;

				${
					$hideDefaultCloseButton &&
					css`
						& > button {
							display: none;
						}
					`
				}

				> div:first-of-type {
					height: 100%;
					max-height: initial;

					> div:first-of-type {
						height: 100%;

						> div:first-of-type {
							height: 100%;
						}
					}
				}
			}

			@media (min-width: ${MODAL_BREAKPOINT}) {
				& div[role='dialog']:first-of-type {
					position: relative;
					max-width: ${$desktopMaxWidth}px;

					> div:first-of-type {
						height: auto;
						max-height: initial;

						> div:first-of-type {
							height: auto;

							> div:first-of-type {
								height: auto;
							}
						}
					}
				}
			}
		`}

	${({ $layout, $hideDefaultCloseButton }) =>
		$layout !== 'fullScreenOnMobileCustom' &&
		$hideDefaultCloseButton &&
		css`
			& div[role='dialog']:first-of-type > button {
				display: none;
			}
		`}
`
